import { TelemetryEvent } from "@microsoft/oteljs";
import  * as UserFacts from "@ms-ofb/officepersonalization/dist/lib/Facts/UserFacts";

export function processTelemetryEvent(telemetryEvent: TelemetryEvent): void {
    UserFacts.processTelemetryEvent(telemetryEvent);
}